/* eslint-disable react/no-multi-comp */

import classNames from 'classnames';
import styled from 'astroturf'
import qsa from 'dom-helpers/query/querySelectorAll';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import * as ReactBootstrap from 'react-bootstrap';
import * as formik from 'formik';
import yup from 'yup';
import {
  LiveProvider,
  LiveEditor,
  LiveError,
  LivePreview,
  withLive,
} from 'react-live';

import PlaceholderImage from './PlaceholderImage';
import Sonnet from './Sonnet';

const scope = {
  ...ReactBootstrap,
  ReactDOM,
  classNames,
  PropTypes,
  Sonnet,
  formik,
  yup,
  PlaceholderImage,
};

const StyledError = styled(LiveError, null, "StyledError", require("./ReactPlayground-StyledError.module.scss"), "styled-error", "styledError");

const StyledProvider = styled(LiveProvider, null, "StyledProvider", require("./ReactPlayground-StyledProvider.module.scss"), "styled-provider", "styledProvider");

const StyledEditor = styled(LiveEditor, null, "StyledEditor", require("./ReactPlayground-StyledEditor.module.scss"), "styled-editor", "styledEditor");

const EditorInfoMessage = styled('div', null, "EditorInfoMessage", require("./ReactPlayground-EditorInfoMessage.module.scss"), "editor-info-message", "editorInfoMessage");

const StyledExample = styled('div', null, "StyledExample", require("./ReactPlayground-StyledExample.module.scss"), "styled-example", "styledExample");

let uid = 0;

class Editor extends React.Component {
  state = { ignoreTab: false };

  id = `described-by-${++uid}`;

  handleKeyDown = event => {
    const { key } = event;

    if (this.state.ignoreTab && key !== 'Tab' && key !== 'Shift') {
      if (key === 'Enter') event.preventDefault();
      this.setState({ ignoreTab: false });
    }
    if (!this.state.ignoreTab && key === 'Escape') {
      this.setState({ ignoreTab: true });
    }
  };

  handleFocus = e => {
    if (e.target !== e.currentTarget) return;
    this.setState({
      ignoreTab: !this.mouseDown,
      keyboardFocused: !this.mouseDown,
    });
  };

  handleMouseDown = () => {
    this.mouseDown = true;
    window.setTimeout(() => {
      this.mouseDown = false;
    }, 0);
  };

  render() {
    const { keyboardFocused, ignoreTab } = this.state;
    return (
      <div className="position-relative">
        <StyledEditor
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onKeyDown={this.handleKeyDown}
          onMouseDown={this.handleMouseDown}
          ignoreTabKey={ignoreTab}
          aria-describedby={this.id}
          aria-label="Example code editor"
        />
        {(keyboardFocused || !ignoreTab) && (
          <EditorInfoMessage id={this.id} aria-live="polite">
            {ignoreTab ? (
              <>
                Press <kbd>enter</kbd> or type a key to enable tab-to-indent
              </>
            ) : (
              <>
                Press <kbd>esc</kbd> to disable tab trapping
              </>
            )}
          </EditorInfoMessage>
        )}
      </div>
    );
  }
}

const prettierComment = /(\{\s*\/\*\s+prettier-ignore\s+\*\/\s*\})|(\/\/\s+prettier-ignore)/gim;

const { background, foreground } = require('./ReactPlayground-null.module.scss');

const Preview = withLive(
  class extends React.Component {
    constructor() {
      super();

      this.example = null;
    }

    componentDidMount() {
      import('holderjs').then(({ default: hjs }) => {
        this.hjs = hjs;
        hjs.addTheme('gray', {
          bg: background,
          fg: foreground,
          font: 'Helvetica',
          fontweight: 'normal',
        });
        this.runHolder();
      });
    }

    componentDidUpdate(prevProps) {
      if (prevProps.live.element !== this.props.live.element) this.runHolder();
    }

    // prevent links in examples from navigating
    handleClick = e => {
      if (e.target.tagName === 'A') e.preventDefault();
    };

    attachRef = ref => {
      this.example = ref;
      this.runHolder();
    };

    runHolder() {
      if (!this.hjs || !this.example) return;

      this.hjs.run({
        theme: 'gray',
        images: qsa(this.example, 'img'),
      });
    }

    render() {
      const { showCode, className } = this.props;
      return (
        <>
          <StyledExample
            role="region"
            aria-label="Code Example"
            ref={this.attachRef}
            showCode={showCode}
            className={className}
            onClick={this.handleClick}
          >
            <LivePreview />
          </StyledExample>
          <StyledError />
        </>
      );
    }
  },
);

// eslint-disable-next-line react/no-multi-comp
export default class Playground extends React.Component {
  static propTypes = {
    codeText: PropTypes.string.isRequired,
  };

  render() {
    const { codeText, exampleClassName, showCode = true } = this.props;

    return (
      <StyledProvider
        scope={scope}
        code={codeText.replace(prettierComment, '')}
        mountStylesheet={false}
        noInline={codeText.includes('render(')}
      >
        <Preview showCode={showCode} className={exampleClassName} />
        {showCode && <Editor onChange={this.handleChange} />}
      </StyledProvider>
    );
  }
}
